import { z } from 'zod'

import type { NoContext } from '~/services/api/contracts/NoContext'
import { NotificationPreferencesSchemaQuerySchema, UserRoleSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

// NotificationSchemaRequest::prepareForValidation
const normalize = fieldNormalizer({ enums: [{ field: 'role', options: UserRoleSchema.options }] })

export const NotificationPreferencesSchema = (_context: NoContext = {}) =>
  z.preprocess(normalize, NotificationPreferencesSchemaQuerySchema)
